import { useState, useEffect } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent,
  PaginationComponent,
  EmployeeWithProfile
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const, colors } from "../../constants";
import { Badge, message } from 'antd';
import { FilterComponent, FilterButton } from "@comps/components";
import { deleteDataReq, getAllDataReq, getFilterReq } from "./requests";
import { useSelector } from "react-redux";
import moment from "moment";
import ViewFlow from '@mods/common/ViewFlow';
import ViewLeaveRequestHistory from "../../common/ViewLeaveRequestHistory";
import CreateRelaxationRequest from "./components/CreateRelaxationRequest";
import ViewRelaxationRequest from "./components/ViewRelaxationRequest";
import { getRequestFilters } from '@mods/common/commonFilterFields';
const langKey = Const["relaxationRequest"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["relaxationRequest"].route
      }
    ]
  }
}

const IndexRelaxationRequests = (props) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);

  const [filters, setFilters] = useState(`employee_|${authUser.employment_id}`);
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================

  const columns = [
    {
      key: 'code',
      title: trans(Commons.code),
      dataIndex: "code",
    },
    {
      key: 'date',
      title: trans(`${langKey}.date`),
      render: (record) => {
        return moment(record.date).format('YYYY-MM-DD')
      }
    },
    {
      key: 'time_slot_name',
      title: trans(`${langKey}.time_slot_name`),
      dataIndex: "time_slot_name",
    },
    {
      key: 'time',
      title: trans(`${langKey}.time`),
      render: (record) => {
        return moment(record.start_time).format('hh:mm a') + '-To-' + moment(record.end_time).format('hh:mm a')
      }
    },
    {
      key: 'duration',
      title: trans(`${langKey}.duration`),
      render: (record) => {
        return (Math.floor(record.minutes) >= 60 ? Math.floor(record.minutes / 60) + 'h ' + record.minutes % 60 + 'm' : Math.floor(record.minutes) + 'm')
      }
    },
    {
      key: 'next_requestee',
      title: trans(`${langKey}.next_requestee`),
      render: (record) => {
        return <EmployeeWithProfile record={ record.next_requestee_name } />
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      render: (record) => {
        return <Badge
          count={ record.status ? record.status : 'none' }
          style={ { background: colors[record.status_class], color: colors[record.status_class + '-color'] } }
        />
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onViewHistory={ record.status !== 'Pending' ? onViewHistory : '' }
          onViewFlow={ record.flow.length !== 0 ? onViewFlow : '' }
          onEdit={ record.status === 'Pending' ? onEdit : '' }
          onView={ onView }
          onDelete={ record.status === 'Pending' ? onDelete : '' }
          onCancelRequest={ (record.status !== 'Pending') ? (record.status !== 'Cancelled') ? onCancelRequest : '' : '' }
        >
        </ActionComponent>
      ),
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);
  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (response) => {
    setPagination(response.relaxations);
    setDataSource(response.relaxations.data);
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const onEdit = (record) => {
    setChildComponent(
      <ViewRelaxationRequest onCompleted={ onCompleted } record={ record } disabled={ false } action='edit' getAllData={ getAllData } />
    );
  };
  const onView = (record) => {
    setChildComponent(
      <ViewRelaxationRequest onCompleted={ onCompleted } record={ record } disabled={ true } action='view' />
    );
  };
  const onCancelRequest = (record) => {
    setChildComponent(
      <ViewRelaxationRequest onCompleted={ onCompleted } record={ record } disabled={ true } action='cancel' />
    );
  };
  const onViewHistory = (record) => {
    setChildComponent(
      <ViewLeaveRequestHistory onCompleted={ onCompleted } record={ record } disabled={ true } subTitle={ trans(Commons.history) } />
    );
  };
  const onViewFlow = (record) => {
    setChildComponent(
      <ViewFlow onCompleted={ onCompleted } record={ record } disabled={ true } subTitle={ trans(Commons.flow) } />
    );
  };
  const onDelete = (record) => {
    const payload = {
      filters: `employee_|${record.employment_id}`, id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    setDataSource(res.relaxations.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateRelaxationRequest onCompleted={ onCompleted } authUser={ authUser } relaxationof={ props.relaxationof } onSuccess={ onSuccess } />);
  };

  const onCompleted = (data) => {
    if (data.length) {
      setDataSource(data);
    }
    setChildComponent(null);
  };

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || "id",
      sortType: sorter.order === "ascend" ? "asc" : "desc",
    };
    setPagination(payload);
  };

  //---------------filters-----------------------
  const onOpenFilter = () => {
    setChildComponent(<FilterComponent filters={ filterFields } modkey={ props.modkey } selected={ filters } api={ getFilterReq } setCurrentPage={ setCurrentPage } onFilter={ setFilters } onCloseFilter={ onCloseFilter }
    />
    )
  }

  const onCloseFilter = () => {
    setChildComponent(null);

  }

  //----end filter--------------------

  return (
    <>

      { childComponent }
      <BodyComponent>
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
          <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
          <FilterButton onClick={ onOpenFilter } />
        </HeaderComponent>
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          pagination={ { ...pagination, total: totalRecords } }
          onChange={ handleTableChange }
        />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexRelaxationRequests;
const filterFields = getRequestFilters({ hideSelfScopeFilters: true })
